<template>
  <Panel header="Danh sách dân cư trong tổ">
    <div class="w-full">
      <div class="rounded-lg border border-slate-200 bg-white p-4"  v-if="adminPermission">
        <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
          <div class="flex min-w-0 flex-col md:col-span-5 lg:col-span-4">
            <Dropdown
                id="civilGroup"
                v-model="idCivilGroupSelect"
                :options="listCivilGroupNew"
                optionLabel="civilGroupName"
                optionValue="id"
                @change="selectedCivilGroup"
                placeholder="Vui lòng chọn tổ..."
                :filter="true"
                class="w-full"
            />
          </div>
          <div class="flex min-w-0 flex-col md:col-span-3 lg:col-span-2">
            <Button
                label="Tất cả công dân"
                icon="pi pi-list"
                iconPos="left"
                @click="getAll()"
            />
          </div>
        </div>
      </div>
      <DataTable
        :loading="isLoading"
        :value="listPeople"
        :paginator="true"
        stripedRows
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        :rowHover="true"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        v-model:filters="filters"
        :globalFilterFields="['fullName', 'phoneNumber']"
        currentPageReportTemplate="Có tổng số {totalRecords} cư dân"
        resizableColumns
        tableclass="h-[60px]"
      >
        <template #header>
          <div class="flex flex-wrap items-center justify-between gap-3">
            <div class="flex w-full flex-col gap-3">
              <div class="flex gap-3">
                <Button
                  type="button"
                  icon="pi pi-filter-slash"
                  label="Xoá"
                  outlined
                  @click="clearFilter()"
                  class="w-[6em]"
                />
                <span class="relative flex flex-1">
                  <i
                    class="pi pi-search pointer-events-none absolute left-3 top-1/2 z-10 -translate-y-1/2 text-sm text-slate-400"
                  />
                  <InputText
                    class="!w-[500px] !pl-10 !pr-3"
                    v-model="filters['global'].value"
                    placeholder="Tìm theo tên hoặc số điện thoại"
                  />
                </span>
              </div>
              <Button
                  v-if="!adminPermission"
                type="button"
                icon="pi pi-trash"
                label="Xoá đã chọn"
                severity="danger"
                @click="deleteSelectedPeople()"
                :loading="deletingSelected"
                :disabled="selectedPeopleIds.length < 1"
                class="w-fit"
              />
            </div>
          </div>
        </template>

        <Column header="" class="h-[60px]">
          <template #header>
            <Checkbox
              :modelValue="isAllSelected"
              :binary="true"
              @update:modelValue="toggleSelectAll"
            />
          </template>
          <template #body="slotProps">
            <Checkbox
              :modelValue="isSelected(slotProps.data)"
              :binary="true"
              @update:modelValue="toggleSelect(slotProps.data)"
            />
          </template>
        </Column>
        <Column
          field="fullName"
          header="Họ và tên"
          sortable
          class="h-[60px]"
        ></Column>
        <Column
          field="phoneNumber"
          header="Số điện thoại"
          class="h-[60px]"
          sortable
        ></Column>
        <Column
          field="civilGroup"
          header="Thôn/Tổ"
          class="h-[60px]"
          sortable
        ></Column>
        <Column header="Thao tác" class="h-[60px]"  v-if="!adminPermission">
          <template #body="slotProps">
            <div class="flex flex-wrap gap-2">
              <Button
                severity="info"
                label="Sửa"
                icon="pi pi-pencil"
                @click="openEditResident(slotProps.data)"
                :disabled="deletingId === getPersonId(slotProps.data)"
                class="!min-h-[36px] px-3 py-1.5"
              />
              <Button
                severity="danger"
                label="Xoá"
                icon="pi pi-trash"
                @click="deletePerson(slotProps.data)"
                :loading="deletingId === getPersonId(slotProps.data)"
                class="!min-h-[36px] px-3 py-1.5"
              />
            </div>
          </template>
        </Column>

        <!--              <Button  type="button" label="Chỉnh sửa" icon="pi pi-pencil">-->
        <!--              </Button>-->
        <!--            </router-link>-->
        <!--          </template>-->
        <!--        </Column>-->
      </DataTable>
    </div>

    <Dialog
      v-model:visible="isEditDialogVisible"
      header="Sửa thông tin dân cư"
      modal
      :style="{ width: 'min(520px, calc(100vw - 32px))' }"
    >
      <div class="flex flex-col gap-4">
        <div class="flex min-w-0 flex-col">
          <label for="editFullName">Họ và tên</label>
          <InputText
            id="editFullName"
            v-model="editForm.fullName"
            placeholder="Nhập họ và tên"
          />
        </div>
        <div class="flex min-w-0 flex-col">
          <label for="editPhoneNumber">Số điện thoại</label>
          <InputText
            id="editPhoneNumber"
            v-model="editForm.phoneNumber"
            placeholder="Nhập số điện thoại"
            @keyup.enter="updateResident()"
          />
        </div>
      </div>

      <template #footer>
        <div class="flex justify-end gap-2">
          <Button
            label="Huỷ"
            icon="pi pi-times"
            severity="secondary"
            outlined
            @click="closeEditDialog()"
            :disabled="isUpdating"
          />
          <Button
            label="Lưu"
            icon="pi pi-check"
            @click="updateResident()"
            :loading="isUpdating"
            :disabled="!canUpdateResident"
          />
        </div>
      </template>
    </Dialog>

    <!-- Confirm Delete Modal -->
    <ConfirmDeleteModal
      v-model="showConfirmModal"
      :title="confirmTitle"
      :message="confirmMessage"
      :is-loading="isConfirming"
      @confirm="confirmAction"
      @cancel="cancelAction"
    />
  </Panel>
</template>

<script lang="ts">
import { computed, ref } from "vue";
import { useToast } from "@/ui/services/toast";
import AuthRepository from "@/services/AuthRepository";
import { useStore } from "vuex";
import router from "@/router";
import { FilterMatchMode } from "@/ui/services/api";
import { Team } from "@/models/team.models";
import TeamRepository from "@/services/TeamRepository";
import moment from "moment";
import authRepository from "@/services/AuthRepository";
import { UserDetail } from "@/models/userDetail";
import { CustomerUpdate } from "@/models/customerUpdate";
import zaloRepository from "@/services/ZaloRepository";
import { ListGroup } from "@/models/listGroup";
import { RegisterCivilGroup } from "@/models/registerCivilGroup";
import ConfirmDeleteModal from "@/components/ConfirmDeleteModal.vue";
import { useConfirmDelete } from "@/composables/useConfirmDelete";
import CivilGroup from "@/models/CivilGroup.models";

export default {
  components: {
    ConfirmDeleteModal,
  },
  setup() {
    const toast = useToast();
    const isLoading = ref(false);
    const list = ref([] as CustomerUpdate[]);
    type ResidentRow = RegisterCivilGroup & { id?: number | string };
    const listPeople = ref([] as ResidentRow[]);
    const listPeopleTemp = ref([] as ResidentRow[]);
    const listTemp = ref([] as CustomerUpdate[]);
    const store = useStore();
    const adminPermission = ref(false);
    const selectedPeopleIds = ref<number[]>([]);
    const deletingSelected = ref(false);
    const deletingId = ref<number | null>(null);
    const isEditDialogVisible = ref(false);
    const isUpdating = ref(false);
    const editForm = ref({
      id: 0,
      fullName: "",
      phoneNumber: "",
    });
    const canUpdateResident = computed(
      () =>
        editForm.value.id > 0 &&
        editForm.value.fullName.trim().length > 0 &&
        editForm.value.phoneNumber.trim().length > 0,
    );

    // Use confirm delete composable
    const confirmDelete = useConfirmDelete();
    const showConfirmModal = confirmDelete.isOpen;
    const confirmTitle = confirmDelete.title;
    const confirmMessage = confirmDelete.message;
    const isConfirming = confirmDelete.isLoading;
    const idCivilGroupSelect = ref(0);

    if(store.state.permission == "admin")
    {
      adminPermission.value = true;
    }

    // if(!(store.state.permission == "admin")){
    //   router.push({
    //     name: 'home'
    //   });
    // }
    const listCivilGroupNew = ref([] as CivilGroup[]);
    const selectWard = () => {
      listCivilGroupNew.value = [];
      // if((userUpdate.value.permission == "civilGroup"))
      {
        zaloRepository
            .getListCivilGroup()
            .then((response) => {
              listCivilGroupNew.value = response.data;
              loadListPeople();
            })
            .catch((err) => {
              toast.add({
                severity: "error",
                summary: "Lỗi",
                detail: err.response.data,
                life: 2000,
              });
            });
      }
    };
    selectWard();

    const listCivilGroup = ref([] as ListGroup[]);
    const civilGroupSelect = ref({} as ListGroup);

    console.log(
      "@@@@@@@@@@@@@@@@@@@ selectCivilGroup store.state.permission: " +
        store.state.permission,
    );

    const getPersonId = (person: ResidentRow) =>
      Number(
        (person as any).id ??
          (person as any).idPeople ??
          (person as any).idRegisterCivilGroup,
      );

    const loadListPeople = () => {
      isLoading.value = true;
      zaloRepository
        .getListPeopleCivilGroupByToken()
        .then((response) => {
          listPeople.value = response.data;
          console.log(
              "@@@@@@@@@@@@@@@@@@@ loadListPeople response.data: " +
              JSON.stringify(response.data)
          );
          const currentIds = new Set(listPeople.value.map(getPersonId));
          selectedPeopleIds.value = selectedPeopleIds.value.filter((id) =>
            currentIds.has(id),
          );
          console.log(
              "@@@@@@@@@@@@@@@@@@@ loadListPeople listPeople.value: " +
              JSON.stringify(listPeople.value)
          );
          console.log(
              "@@@@@@@@@@@@@@@@@@@ loadListPeople listCivilGroupNew.value: " +
              JSON.stringify(listCivilGroupNew.value)
          );
          listPeople.value.forEach(x => {
            console.log(
                "@@@@@@@@@@@@@@@@@@@ loadListPeople x: " +
                JSON.stringify(x)
            );

            listCivilGroupNew.value.forEach(y => {
              if(y.id == x.idCivilGroup){

                x.civilGroup = y.civilGroupName;
                console.log(
                    "@@@@@@@@@@@@@@@@@@@ loadListPeople y: " +
                    JSON.stringify(y)
                );
              }
            })
          })
          listPeopleTemp.value = listPeople.value;
          console.log(
              "@@@@@@@@@@@@@@@@@@@ loadListPeople  22222 listPeople.value: " +
              JSON.stringify(listPeople.value)
          );
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: "Lỗi khi tải danh sách công dân",
            life: 2000,
          });
        })
        .finally(() => {
          isLoading.value = false;
        });
    };

    const selectedCivilGroup = () => {
      console.log(
          "@@@@@@@@@@@@@@@@@@@ selectedCivilGroup  idCivilGroupSelect.value: " +
          JSON.stringify(idCivilGroupSelect.value)
      );
      if(idCivilGroupSelect.value > 0) {
        listPeople.value = listPeopleTemp.value.filter(x => x.idCivilGroup == idCivilGroupSelect.value);
      }
    }

    //loadListPeople();

    zaloRepository
      .getListCustomerDetail()
      .then((response) => {
        listTemp.value = list.value = response.data;
        const civilGroupAll = ref({} as ListGroup);
        civilGroupAll.value.name = "Tất cả";
        listCivilGroup.value.push(civilGroupAll.value);
        list.value.forEach((x) => {
          const check = ref(false);
          listCivilGroup.value.forEach((y) => {
            if (y.name == x.civilGroupName) check.value = true;
          });
          if (!check.value && x.civilGroupName != null) {
            const civilGroup = ref({} as ListGroup);
            civilGroup.value.name = x.civilGroupName;
            listCivilGroup.value.push(civilGroup.value);
          }
        });
      })
      .catch((err) => {
        toast.add({
          severity: "error",
          summary: "Lỗi",
          detail: "Lỗi khi tải danh sách công dân",
          life: 2000,
        });
      });

    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const clearFilter = () => {
      initFilters();
    };

    const initFilters = () => {
      filters.value = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      };
    };
    const formatDateTime = (date) => {
      return moment(String(date)).format("DD/MM/YYYY");
    };
    const permissionName = (st) => {
      if (st == "master") return "Quản lý tòa nhà";
      else return "Nhân viên công ty";
    };

    const isSelected = (person: ResidentRow) => {
      const id = getPersonId(person);
      return selectedPeopleIds.value.includes(id);
    };

    const isAllSelected = computed(
      () =>
        listPeople.value.length > 0 &&
        listPeople.value.every((person) =>
          selectedPeopleIds.value.includes(getPersonId(person)),
        ),
    );

    const toggleSelect = (person: ResidentRow) => {
      const id = getPersonId(person);
      if (!id) return;
      if (selectedPeopleIds.value.includes(id)) {
        selectedPeopleIds.value = selectedPeopleIds.value.filter(
          (item) => item !== id,
        );
      } else {
        selectedPeopleIds.value = [...selectedPeopleIds.value, id];
      }
    };

    const toggleSelectAll = (checked: boolean) => {
      selectedPeopleIds.value = checked
        ? listPeople.value.map(getPersonId).filter(Boolean)
        : [];
    };

    const deletePeople = (idList: number[]) => {
      if (idList.length < 1) return Promise.resolve();
      return zaloRepository
        .deletePeopleByToken(idList, false)
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Xoá dân cư thành công",
            life: 2000,
          });
          selectedPeopleIds.value = selectedPeopleIds.value.filter(
            (id) => !idList.includes(id),
          );
          selectWard();
          //loadListPeople();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Xoá dân cư không thành công",
            life: 2500,
          });
        });
    };

    const openConfirm = (
      title: string,
      message: string,
      callback: () => Promise<void>,
    ) => {
      confirmDelete.open({
        title,
        message,
        onConfirm: callback,
      });
    };

    const confirmAction = () => {
      confirmDelete.confirm();
    };

    const cancelAction = () => {
      confirmDelete.cancel();
    };

    const deletePerson = (person: ResidentRow) => {
      const id = getPersonId(person);
      if (!id) return;
      openConfirm(
        "Xác nhận xoá",
        "Bạn có chắc chắn muốn xoá dân cư này?",
        () => {
          deletingId.value = id;
          return deletePeople([id]).finally(() => {
            deletingId.value = null;
          });
        },
      );
    };

    const deleteSelectedPeople = () => {
      const count = selectedPeopleIds.value.length;
      openConfirm(
        "Xác nhận xoá",
        `Bạn có chắc chắn muốn xoá ${count} dân cư đã chọn?`,
        () => {
          deletingSelected.value = true;
          return deletePeople([...selectedPeopleIds.value]).finally(() => {
            deletingSelected.value = false;
          });
        },
      );
    };

    const openEditResident = (person: ResidentRow) => {
      const id = getPersonId(person);
      if (!id) return;
      editForm.value = {
        id,
        fullName: person.fullName || "",
        phoneNumber: person.phoneNumber || "",
      };
      isEditDialogVisible.value = true;
    };

    const closeEditDialog = () => {
      if (isUpdating.value) return;
      isEditDialogVisible.value = false;
    };

    const updateResident = () => {
      if (!canUpdateResident.value || isUpdating.value) return;
      isUpdating.value = true;
      zaloRepository
        .updateRegisterCivilGroup({
          id: editForm.value.id,
          fullName: editForm.value.fullName.trim(),
          phoneNumber: editForm.value.phoneNumber.trim(),
        })
        .then(() => {
          toast.add({
            severity: "success",
            summary: "Thành công",
            detail: "Cập nhật dân cư thành công",
            life: 2000,
          });
          isEditDialogVisible.value = false;
          selectWard();
          //loadListPeople();
        })
        .catch((err) => {
          toast.add({
            severity: "error",
            summary: "Lỗi",
            detail: err.response?.data || "Cập nhật dân cư không thành công",
            life: 2500,
          });
        })
        .finally(() => {
          isUpdating.value = false;
        });
    };

    const selectCivilGroup = () => {
      console.log(
        "@@@@@@@@@@@@@@@@@@@ selectCivilGroup civilGroupSelect: " +
          JSON.stringify(civilGroupSelect.value),
      );
      console.log(
        "@@@@@@@@@@@@@@@@@@@ selectCivilGroup civilGroupSelect name: " +
          civilGroupSelect.value.name,
      );
      if (civilGroupSelect.value.name == "Tất cả") {
        listTemp.value = list.value;
      } else {
        listTemp.value = list.value.filter(
          (x) => x.civilGroupName == civilGroupSelect.value.name,
        );
      }
      console.log(
        "@@@@@@@@@@@@@@@@@@@ selectCivilGroup civilGroupSelect listTemp: " +
          JSON.stringify(listTemp.value),
      );
    };

    const getAll = () => {
      listPeople.value = listPeopleTemp.value;
      idCivilGroupSelect.value = 0;
    }

    return {
      list,
      filters,
      clearFilter,
      initFilters,
      formatDateTime,
      permissionName,
      listCivilGroup,
      selectCivilGroup,
      civilGroupSelect,
      listTemp,
      adminPermission,
      listPeople,
      selectedPeopleIds,
      isSelected,
      isAllSelected,
      toggleSelect,
      toggleSelectAll,
      deletePerson,
      deleteSelectedPeople,
      deletingSelected,
      deletingId,
      getPersonId,
      isEditDialogVisible,
      editForm,
      isUpdating,
      canUpdateResident,
      openEditResident,
      closeEditDialog,
      updateResident,
      // Custom modal
      showConfirmModal,
      confirmTitle,
      confirmMessage,
      confirmAction,
      cancelAction,
      isConfirming,
      idCivilGroupSelect,
      listCivilGroupNew,
      selectedCivilGroup,
      getAll,
    };
  },
};
</script>
`r`n
